<template>

  <b-input-group v-if="showInput">
    <b-form-input
        :placeholder="label"
        :value="value"
        @input="$emit('input',$event)"
    />
    <b-input-group-append>
      <b-button variant="outline-primary" @click="search">
        <b-icon-x/>
      </b-button>
    </b-input-group-append>
  </b-input-group>
  <div
      class="d-inline-flex align-items-center font-weight-bold"
      style="height: 38px"
      @click="search"
      v-else>
    <div>{{ label }}</div>
    <!--    #Fake DropDown toggle for search UI consistency-->
    <div class="dropdown b-dropdown btn-group">
      <b-button size="sm" variant="link" class="dropdown-toggle text-decoration-none dropdown-toggle-no-caret">
        <b-icon-search></b-icon-search>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name : "SearchableLabel",
  props: ["label", "value"],
  data() {
    return {showInput: false}
  },
  methods: {
    search($event) {
      $event.stopPropagation();
      this.showInput = !this.showInput;
    }
  }
}
</script>

<style scoped>

</style>